module.exports = __webpack_public_path__ + "static/media/17.e6fc33d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/17.svg
// module id = 129
// module chunks = 0